import BaseModel from './BaseModel';

class Stock extends BaseModel {
  ticker;
  sector;
  country;
  lastPrice;
  regularMarketChange;
  targetPrice;
  beta;
  recommendationKey;
  dividendYield;
}

export default Stock;
